module.exports = __webpack_public_path__ + "static/media/PWI_Icon_btn_303.f11cf9c6.svg";